import fb from '@/services/firebase.js'

export const namespaced = true

export const state = {
  code: {}
}

export const mutations = {
  SET_CODE(state, value) {
    state.code = value
  }
}

export const actions = {
  confirmCode({ commit }, code) {
    fb.db
      .collection('promo_code')
      .where('code', '==', code)
      .get()
      .then(docs => {
        if (docs.empty == false) {
          docs.forEach(doc => {
            if (doc.exists) {
              commit('SET_CODE', doc.data())
            }
          })
        } else {
          commit('SET_CODE', {})
        }
      })
  }
}

export const getters = {}
